
function SearchInputComponent() {
    for (let searchInputComponent of document.querySelectorAll('.search-input')) {
    console.log("Search input", searchInputComponent);
        let input = searchInputComponent.querySelector('input');
        let clear = searchInputComponent.querySelector('.clear');
        clear.addEventListener('click', function() {
            input.value = "";
            input.focus();
        });
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', SearchInputComponent);
}
else {
    SearchInputComponent();
}
